// src/components/ImpactionConstants.js

export const IMPACTION_TEETH = ['38', '48', '13', '23'];

export const IMPACTION_REPORT_TYPES = ['Mandible', 'Maxilla'];

// TOOTH POSITION AND DEVELOPMENT
export const DEVELOPMENT_STATUS_OPTIONS = [
    'Completely formed - crown complete',
    'Developing root apex (open apex)',
];

export const DEVELOPMENT_STATUS_OPTIONS_MANDIBLE = [
    'Tooth is completely formed',
    'Crown is completely formed, Developing root till cervical-3rd',
    'Crown is completely formed, Developing root till mid-3rd',
    'Crown is completely formed, Developing root till apical-3rd',
    'Crown is completely formed, Developing root with open apex'
];
// ... (rest of file)


export const ERUPTION_STATUS_OPTIONS = [
    'Impacted',
    'Erupted',
    'Partially erupted'
];

export const IMPACTION_TYPE_OPTIONS = [
    'Vertical',
    'Mesioangular',
    'Distoangular',
    'Horizontal',
    'Transverse',
    'Inverted',
    'Ectopic'
];

export const IMPACTION_TYPE_OPTIONS_MANDIBLE = [
    'Vertical',
    'Mesioangular',
    'Distoangular',
    'Horizontal',
    'Transverse',
    'Inverted',
    'Ectopic',
    'Buccolingual'
];

export const ECTOPIC_LOCATION_OPTIONS = [
    'Ramus',
    'Coronoid process',
    'Near angle of mandible'
];

// EXTENSIONS
export const EXTENSION_SUPERIOR_OPTIONS = [
    'At occlusal plane',
    'Above occlusal plane',
    'Below occlusal plane',
    'At alveolar crest',
    'Below alveolar crest'
];

export const EXTENSION_INFERIOR_OPTIONS = [
    'At superior cortical border of IANC',
    'Above IANC',
    'Inferior border of mandible',
    'Above angle of mandible'
];

export const EXTENSION_MESIAL_OPTIONS = [
    'In contact with adjacent tooth',
    'From distal surface of adjacent tooth',
    'Overlapping adjacent root',
    'Divergent',
    'No mesial contact'
];

export const EXTENSION_MESIAL_OPTIONS_MANDIBLE = [
    'In contact with adjacent tooth',
    'In close proximity to the adjacent tooth',
    'In close proximity to the adjacent crown',
    'In close proximity to the adjacent root'
];

export const EXTENSION_DISTAL_OPTIONS = [
    'Anterior to ascending ramus',
    'At ascending ramus',
    'Extending into ramus'
];

export const EXTENSION_BUCCOLINGUAL_OPTIONS = [
    'Crown is close to buccal cortical bone',
    'Crown is close to lingual cortical bone',
    'Crown is located equidistant from buccal and lingual cortical bone',
    'Root is close to buccal cortical bone',
    'Root is close to lingual cortical bone',
    'Root is located equidistant from buccal and lingual cortical bone',
    'Crown and root are located equidistant from buccal and lingual cortical bone',
    'Crown and root are close to buccal cortical bone'
];

export const BUCCOLINGUAL_CROWN_OPTIONS = [
    'Crown close to buccal cortex',
    'Crown close to lingual cortex',
    'Crown equidistant to buccal and lingual cortex'
];

export const BUCCOLINGUAL_ROOT_OPTIONS = [
    'Root close to buccal cortex',
    'Root close to lingual cortex',
    'Root equidistant to buccal and lingual cortex'
];

// CROWN FEATURES
export const CROWN_SHAPE_OPTIONS = ['Bulbous', 'Normal', 'Abnormal'];
export const CROWN_MARGIN_OPTIONS = ['Well-delineated', 'Poorly delineated', 'Irregular'];
export const CROWN_DEFECT_OPTIONS = ['None', 'Deep caries', 'Superficial caries', 'Previous restoration', 'Crown prosthesis', 'Loss of crown structure', 'Grossly destructed'];
export const CROWN_ALIGNMENT_OPTIONS = ['Mesial tilt', 'Distal tilt', 'Horizontal', 'Buccal tilt', 'Lingual tilt', 'Rotated'];
export const FOLLICULAR_CHANGE_OPTIONS = ['Normal', 'Enlarged', 'Disrupted', 'Early cystic changes'];
export const PREVIOUS_INTERVENTION_OPTIONS = ['None', 'Surgical defect'];

export const ROTATION_OPTIONS = [
    'None',
    'Mesiopalatal',
    'Mesiolabial',
    'Distopalatal',
    'Distolabial'
];

// CRESTAL BONE
export const CRESTAL_BONE_OPTIONS = [
    'No significant loss',
    'Localized mesial bone loss',
    'Localized distal bone loss',
    'Horizontal bone loss',
    'Crown coverage by crestal bone'
];

export const PELL_GREGORY_DEPTH_OPTIONS = [
    'Class A (Shallow): Occlusal plane of the third molar is level with the second molar occlusal plane',
    'Class B: Between the occlusal plane and cervical line of the second molar',
    'Class C (Deep): Below the cervical line of the second molar'
];

export const RAMUS_RELATION_OPTIONS = [
    'Class I: Sufficient space for eruption',
    'Class II: Partially covered by ramus',
    'Class III: Completely embedded in ramus'
];

// ROOTS
export const ROOT_NUMBER_OPTIONS = ['Single', 'Two', 'Three', 'Four', 'Five', 'Accessory roots'];
export const ROOT_DEVELOPMENT_OPTIONS = ['Developing root apex', 'Completely formed'];

export const ROOT_NAME_OPTIONS = [
    'Mesial Root',
    'Distal Root',
    'Palatal Root',
    'Buccal Root',
    'Lingual Root',
    'Mesio-buccal Root',
    'Mesio-lingual Root',
    'Disto-buccal Root',
    'Disto-lingual Root',
    'Single Root',
    'Accessory Root'
];

export const ROOT_SHAPE_OPTIONS = ['Normal', 'Thin', 'Thick', 'Long', 'Short', 'Dilacerated', 'Bulbous', 'Hypercementosis'];
export const ROOT_RELATION_OPTIONS = ['Separate', 'Fused', 'Fused till apical 3rd, and bifurcates at root end'];
export const ROOT_CURVATURE_OPTIONS = [
    'Straight',
    'Curved towards Distal/Mesial root',
    'Curved mesially',
    'Curved distally',
    'Curved buccally',
    'Curved lingually',
    'Dilacerated'
];

export const PERIRADICULAR_BONE_OPTIONS = [
    'No abnormality detected',
    'Blunted',
    'Internal / External resorption',
    'Hypercementosis',
    'Secondary cementum'
];

export const PDL_SPACE_OPTIONS = [
    'Normal',
    'Traceable along entire length',
    'PDL widening',
    'Obscured'
];

export const PERIAPICAL_AREA_OPTIONS = ['No abnormality detected', 'Periapical changes noted'];

// IAC RELATIONSHIP
export const IAC_COURSE_OPTIONS = ['Buccoinferiorly', 'Linguoinferiorly', 'Inferiorly'];
export const IAC_PROXIMITY_OPTIONS = ['<1 mm', '1-2 mm', '2-3 mm', '>3 mm'];
export const IAC_CORTICATION_OPTIONS = ['Intact/Corticated', 'Interruption', 'Loss'];
export const IANC_BIFURCATION_OPTIONS = ['Absent', 'Bifurcation', 'Trifurcation']; // Added
export const IANC_BONY_BARRIER_OPTIONS = [
    '<1mm – No bony barrier noted',
    '1-2mm – Extremely thin bony barrier noted',
    '2-3mm – Adequate bony barrier noted',
    '>3mm – Good available bone noted'
];
export const IAC_COMPRESSION_OPTIONS = ['Buccal', 'Lingual', 'Apical', 'Sandwiched between the roots']; // Updated
export const IAC_DISPLACEMENT_OPTIONS = ['Buccal', 'Lingual', 'Apical']; // Renamed from DEVIATION and updated

// ADJACENT TEETH RELATIONSHIP
export const VERTICAL_OCCLUSAL_LEVEL_OPTIONS = [
    'At occlusal plane',
    'Slightly above occlusal plane',
    'Slightly below occlusal plane'
];
export const VERTICAL_AXIS_OPTIONS = ['Parallel', 'Not parallel'];

export const MESIOANGULAR_CONTACT_OPTIONS = [
    'Partially overlapping',
    'Pressing against distal aspect'
];
export const MESIOANGULAR_DAMAGE_OPTIONS = [
    'Caries',
    'Resorption',
    'Surface resorption'
];

export const DISTOANGULAR_CONTACT_OPTIONS = [
    'Partially overlapping',
    'Extending into ramus'
];
export const DISTOANGULAR_FEATURE_OPTIONS = [
    'Flame-shaped radiolucency distal to crown'
];

export const TRANSVERSE_ORIENTATION_OPTIONS = ['Buccal', 'Lingual'];
export const TRANSVERSE_ROOTS_OPTIONS = ['Buccally', 'Lingually'];

// (Removed duplicates)

// MAXILLA SPECIFIC CONSTANTS (13/14)

export const EXTENSION_SUPERIOR_OPTIONS_MAXILLA = [
    'At alveolar crest',
    'Above alveolar crest',
    'Contacting nasal floor',
    'Close to nasal floor',
    'Protruding into maxillary sinus'
];

export const EXTENSION_INFERIOR_OPTIONS_MAXILLA = [
    'At occlusal plane',
    'Above occlusal plane',
    'Below occlusal plane'
];

export const RELATION_NASAL_FLOOR_OPTIONS = [
    'No changes',
    'Thinning of the nasal floor',
    'Cortical perforation'
];

export const RELATION_SINUS_OPTIONS = [
    'No changes',
    'Thinning of the sinus floor',
    'Sinus floor perforation'
];

export const RELATION_NASOPALATINE_OPTIONS = [
    'No changes',
    'Canal displacement (mild/moderate/severe)',
    'Canal compression',
    'Cortical thinning',
    'Perforation'
];

export const EXTENSION_MESIAL_OPTIONS_MAXILLA = [
    'In contact with lateral incisor (LI) crown',
    'In contact with lateral incisor (LI) root',
    'In contact with central incisor (CI) crown',
    'In contact with central incisor (CI) root',
    'Causing root resorption of LI',
    'Causing root resorption of CI',
    'No mesial contact'
];

export const EXTENSION_DISTAL_OPTIONS_MAXILLA = [
    'In contact with first premolar (24) crown',
    'In contact with first premolar (24) root',
    'In contact with second premolar (25) crown',
    'In contact with second premolar (25) root',
    'Causing root resorption of 24',
    'Causing root resorption of 25',
    'No distal contact'
];
